module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/june-fc79f157f2ad6a6a7a0f5b738cbfefa6.png";